const SPRAY_SRC = "/spray-clean.mp3";

// Reproduce el "flish" del pulverizador. Crea un elemento nuevo en cada
// llamada para permitir solapamiento (varios añadidos seguidos a la cesta).
export const playSpray = (volume = 0.5) => {
  try {
    const a = new Audio(SPRAY_SRC);
    a.volume = Math.max(0, Math.min(1, volume));
    const p = a.play();
    if (p && p.catch) p.catch(() => {});
  } catch (e) {
    /* audio no disponible */
  }
};

// Precarga el recurso para que suene sin latencia la primera vez.
export const preloadSpray = () => {
  try {
    const a = new Audio(SPRAY_SRC);
    a.preload = "auto";
    a.load();
  } catch (e) {
    /* ignore */
  }
};
